import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { TrainingGoalCard } from '../components/TrainingGoalCard';
import { Card } from '../components/ui/Card';
import { goals } from '../data/insights';
import { useLocale } from '../contexts/LocaleContext';
export function Goals() {
  const {
    t,
    tl
  } = useLocale();
  return <div className="px-2 pb-2" data-id="element-3121" data-mp="19t105ybr1r0w">
      <PageHeader title={t('stats.goals.title')} subtitle={t('goals.subtitle')} showBack data-id="element-3122" data-mp="19s817jj185tb" />

      <div className="mb-2" data-id="element-3123" data-mp="14upt1vcu9umd">
        <TrainingGoalCard data-id="element-3124" data-mp="14teohtbkkiu7" />
      </div>

      <ul className="space-y-2" data-id="element-3125" data-mp="1itpfcwcvpxfd">
        {goals.map(goal => {
        const pct = Math.min(100, Math.round(goal.current / goal.target * 100));
        return <li key={goal.id} data-id="element-3126" data-mp="1esvq9znpackw">
              <Card className="p-2" data-id="element-3127" data-mp="3kksspte5lq3m">
                <div className="flex items-baseline justify-between gap-2" data-id="element-3128" data-mp="3km3ytzv2n9xw">
                  <p className="min-w-0 text-[13.5px] font-medium text-deep" data-id="element-3129" data-mp="3gjz2uuh5i183">
                    {tl(goal.title)}
                  </p>
                  <p className="bee-num shrink-0 text-[12px] font-bold text-gold-deep" data-id="element-3130" data-mp="18jms6efmaoct">
                    {pct}%
                  </p>
                </div>

                <p className="bee-num mt-1 text-[12px] text-muted" data-id="element-3131" data-mp="1ifppn6zixytf">
                  {goal.current} {t('goals.of')} {goal.target} {tl(goal.unit)}
                </p>

                <div className="mt-2 h-[7px] w-full overflow-hidden rounded-pill bg-sand-deep" data-id="element-3132" data-mp="1n8rarwqbqulg">
                  <span className="block h-full rounded-pill bg-gold" style={{
                width: `${pct}%`
              }} data-id="element-3133" data-mp="1s8dlnziojyr3" />
                </div>

                {goal.deadline && <p className="mt-2 flex items-center gap-1 text-[11px] text-muted" data-id="element-3134" data-mp="265k39qro3req">
                    <CalendarIcon size={12} aria-hidden="true" data-id="element-3135" data-mp="6sobvc8cm1hc" />
                    {tl(goal.deadline)}
                  </p>}
              </Card>
            </li>;
      })}
      </ul>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3136" data-mp="3qtml2z9uolx">
        {t('goals.note')}
      </p>
    </div>;
}